<template>
  <div>
    <template v-if="pms">
      <online-order />
    </template>
    <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";

export default {
  mixins: [components, mixin],

  components: {
    NoPms 
  },

  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["70000"].check;
  },

};
</script>


// WEBPACK FOOTER //
// src/pages/PartII/OnlineOrder/index.vue